import React, { useState, useEffect } from "react";
import { downloadDocument, previewDocument } from "../../services/documentService";

import {
  FaThumbtack,
  FaRegThumbsUp,
  FaThumbsUp,
  FaRegCommentDots,
  FaPaperclip,
  FaUserCircle,
  FaClock,
  FaPaperPlane,
  FaBookmark,
  FaRegBookmark,
  FaFileAlt,
} from "react-icons/fa";


export default function PostCard({
  post,
  onLike,
  onComment,
}) {


  const [liked, setLiked] =
    useState(post?.userLiked ?? false);


  const [saved, setSaved] =
    useState(post?.userSaved ?? false);


  const [showComments, setShowComments] =
    useState(false);


  const [comment, setComment] =
    useState("");



  const attachment =
    post?.attachment ?? null;

const [previewUrl,setPreviewUrl] = useState(null);

console.log("ATTACHMENT:", attachment);

useEffect(()=>{

  const loadPreview = async()=>{

    if(!attachment?.id)
      return;


    try{

      const url =
        await previewDocument(
          attachment
        );

      setPreviewUrl(url);


    }catch(err){

      console.error(
        "Kunde inte skapa preview",
        err
      );

    }

  };


  loadPreview();


  return ()=>{

    if(previewUrl){

      URL.revokeObjectURL(
        previewUrl
      );

    }

  };


},[attachment]);
  const handleLike = async () => {

    setLiked(prev => !prev);

    if(onLike){
      await onLike(post.id);
    }

  };



  const handleSave = () => {

    setSaved(prev => !prev);

  };



  const handleComment = () => {


    if(!comment.trim()){
      return;
    }


    if(onComment){

      onComment(
        post.id,
        comment
      );

    }


    setComment("");

  };



  return (

<article

className="
overflow-hidden
rounded-2xl
border
border-neutral-200
bg-white
transition
hover:border-[#3BAFA3]/40
hover:shadow-md
"

>


{/* HEADER */}

<header

className="
flex
items-start
justify-between
p-6
"

>


<div className="flex gap-4">


{/* AVATAR */}


<div

className="
flex
h-12
w-12
items-center
justify-center
overflow-hidden
rounded-full
bg-[#E8F7F5]
text-[#3BAFA3]
"

>


{
post?.avatar ?


<img

src={post.avatar}

alt={post.author ?? ""}

className="
h-full
w-full
object-cover
"

/>


:

<FaUserCircle size={32}/>


}


</div>



<div>


<div

className="
font-semibold
text-neutral-900
"

>

{post?.author ?? "Okänd användare"}

</div>



<div

className="
mt-2
flex
flex-wrap
items-center
gap-2
text-xs
text-neutral-500
"

>


<span className="flex items-center gap-1">

<FaClock/>

{post?.createdAt ?? ""}

</span>



<span>
•
</span>



{
post?.category &&

<span

className="
rounded-full
bg-neutral-100
px-3
py-1
text-neutral-600
"

>

{post.category}

</span>

}



</div>


</div>


</div>



{
post?.pinned &&

<span

className="
flex
items-center
gap-1
rounded-full
bg-amber-100
px-3
py-1
text-xs
font-medium
text-amber-700
"

>

<FaThumbtack/>

Fäst

</span>

}


</header>
{/* CONTENT */}


<div className="px-6 pb-6">


<h2

className="
mb-3
text-xl
font-semibold
text-neutral-900
"

>

{post?.title ?? "Nytt inlägg"}

</h2>




<p

className="
whitespace-pre-wrap
leading-relaxed
text-neutral-700
"

>

{post?.text ?? ""}

</p>





{/* ATTACHMENT */}
{/* ATTACHMENT */}

{
attachment && (

<div
className="
mt-5
overflow-hidden
rounded-xl
border
border-neutral-200
bg-[#F8FAFA]
"
>


{/* MINI PREVIEW */}

<div
className="
p-4
"
>


{
previewUrl && 
attachment.type?.startsWith("image/")
?

<img

src={previewUrl}

alt={attachment.name}

className="
h-40
w-full
rounded-lg
object-cover
cursor-pointer
"

/>


:

previewUrl &&
attachment.mimeType === "application/pdf"

?

<div

className="
flex
h-40
items-center
justify-center
rounded-lg
bg-white
border
cursor-pointer
"

>

<div
className="
text-center
"
>

<FaFileAlt
size={40}
className="
mx-auto
text-[#3BAFA3]
"
/>


<div
className="
mt-2
text-sm
font-medium
"
>

PDF dokument

</div>


</div>


</div>


:


<div

className="
flex
h-40
items-center
justify-center
rounded-lg
bg-white
"

>

<FaFileAlt
size={40}
className="text-neutral-400"
/>

</div>


}



</div>





{/* INFO */}

<div

className="
flex
items-center
justify-between
border-t
bg-white
px-4
py-3
"

>


<div
className="
flex
items-center
gap-2
text-sm
font-medium
"

>

<FaPaperclip/>

{attachment.name}


</div>




<button

type="button"

onClick={() =>
  downloadDocument(attachment)
}

className="
rounded-lg
bg-[#3BAFA3]
px-3
py-2
text-xs
text-white
hover:bg-[#2F988D]
transition
"

>

Ladda ner

</button>


</div>



</div>

)

}


</div>


{/* ACTIONS */}


<div

className="
flex
flex-wrap
items-center
gap-5
border-t
border-neutral-200
bg-[#FAFCFC]
px-6
py-4
"

>




{/* LIKE */}


<button

onClick={handleLike}

className={`

flex
items-center
gap-2
text-sm
font-medium
transition


${
liked

?

"text-[#3BAFA3]"

:

"text-neutral-500 hover:text-[#3BAFA3]"

}

`}

>


{
liked

?

<FaThumbsUp/>

:

<FaRegThumbsUp/>

}



<span>

{
(post?.likes ?? 0) +
(liked ? 1 : 0)
}

</span>


</button>







{/* COMMENTS */}


<button

onClick={() =>
setShowComments(prev => !prev)
}

className="
flex
items-center
gap-2
text-sm
font-medium
text-neutral-500
hover:text-[#3BAFA3]
"

>


<FaRegCommentDots/>


<span>

{
post?.comments?.length ?? 0
}

</span>


</button>






{/* SAVE */}


<button

onClick={handleSave}

className={`

ml-auto
flex
items-center
gap-2
text-sm
font-medium
transition


${
saved

?

"text-[#3BAFA3]"

:

"text-neutral-500 hover:text-[#3BAFA3]"

}

`}

>


{
saved

?

<FaBookmark/>

:

<FaRegBookmark/>

}


Spara


</button>


</div>

{/* COMMENTS */}


{
showComments && (


<section

className="
border-t
border-neutral-200
bg-white
p-6
"

>


<div className="space-y-4">



{
post?.comments?.length > 0 ?


post.comments.map((item)=>(


<div

key={item.id}

className="
rounded-xl
bg-[#F8FAFA]
p-4
"

>


<div

className="
flex
items-center
gap-2
font-medium
text-neutral-900
"

>


<FaUserCircle

className="
text-[#3BAFA3]
"

/>


{
item.author ??
"Användare"
}


</div>




<p

className="
mt-2
text-sm
leading-relaxed
text-neutral-600
"

>

{
item.text
}


</p>



</div>


))


:


<p

className="
text-sm
text-neutral-500
"

>

Ingen kommentar ännu.

Bli först med att svara.

</p>


}



</div>





{/* NEW COMMENT */}



<div

className="
mt-6
flex
gap-3
"

>



<input


value={comment}


onChange={(e)=>
setComment(e.target.value)
}


onKeyDown={(e)=>{

if(
e.key === "Enter"
&&
!e.shiftKey
){

e.preventDefault();

handleComment();

}

}}


placeholder="Skriv en kommentar..."


className="

flex-1
rounded-xl
border
border-neutral-200
px-4
py-3
outline-none
transition
focus:border-[#3BAFA3]

"


/>






<button

onClick={handleComment}


disabled={!comment.trim()}


className="

flex
items-center
justify-center
rounded-xl
bg-[#3BAFA3]
px-5
text-white
transition
hover:bg-[#2F988D]
disabled:opacity-50

"

>


<FaPaperPlane/>


</button>



</div>



</section>


)

}


</article>

  );

}